function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4 8a8 8 0 10-16 0 8 8 0 0016 0zM6.155 11.998a.606.606 0 01-.458-.21L3.606 9.52a.828.828 0 01-.023-1.065.607.607 0 01.936-.025l1.632 1.766 5.46-5.985a.607.607 0 01.937.02.828.828 0 01-.017 1.065l-5.917 6.492a.606.606 0 01-.459.21z"
});

function SvgPublishDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "#9F9FA4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPublishDraft;